import React, { createContext, useContext } from "react";

import type { GoogleClientIdProviderProps } from "./types";

const GoogleClientIdContext = createContext<string>("");

export const GoogleClientIdProvider: React.FC<GoogleClientIdProviderProps> = ({
  children,
  googleClientId,
}) => {
  return (
    <GoogleClientIdContext.Provider value={googleClientId}>
      {children}
    </GoogleClientIdContext.Provider>
  );
};

export const useGoogleClientId = (): string => {
  return useContext(GoogleClientIdContext);
};
